




























































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSformTable from '../../../components/AMSformTable.vue';
import AMSTable from '../../../components/AMSTable.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSDialog from '../../../components/AMSDialog.vue';
import { allStaff } from '@/api/staff';
import { deleteInstock } from '@/api/stock';
import utils from '@/utils/utils';
import { getModuleName } from '@/utils/utils';
import moment from 'moment';
interface Form {
  number?: string;
  category?: 'Out';
  stockType?: '' | 'PurchaseReturn' | 'Order' | 'TransferOut' | 'Loss' | 'OtherOut';
  stockBeginTime?: String;
  stockEndTime?: String;
  operatorId?: string;
  status?: string;
  productFilter?: string;
}

@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-dialog': AMSDialog
  }
})
export default class StockDetail extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: 'outStock'
    },
    {
      text: '出库单',
      disabled: true
    }
  ];
  lastTime = '';
  startTime = '';
  api: string = '/api/Stock/List';
  form: Form = { category: 'Out' };
  initForm() {
    this.form = { category: 'Out', stockType: '' };
    this.lastTime =''
    this.startTime =''
  }
  rules = {
    number: []
  };
  stockTypeList = [
    { value: '', text: '全部' },
    { value: 'PurchaseReturn', text: '采购退货' },
    { value: 'Order', text: '销售出库' },
    { value: 'TransferOut', text: '调拨出库' },
    { value: 'Loss', text: '盘亏出库' },
    { value: 'OtherOut', text: '其他出库' },
    { value: 'MaterialOrder ', text: '物料申请出库' }
  ];
  statusList = [{ value: '', text: '全部' }, { value: 'Pending', text: '待审核' }, { value: 'Cancel', text: '已取消' }, { value: 'Stocked', text: '已出库' }];
  BeginTime = false;
  EndTime = false;
  date = new Date().toISOString().substr(0, 10);
  deleteDialog = false;
  deleteItemId: string = '';
  requestLoading: boolean = false;
  staffList: Array<object> = [];

  headers = [
    {
      text: '单据号',
      value: 'number',
      sortable: false,
      align: 'left',
      width: 160,
      status: 'status'
    },
    {
      text: '出库类型',
      value: 'type',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(param.row.status) }, this.switchType(param.row[param.keyName]));
      },
      width: 130
    },
    { text: '数量', value: 'quantity', sortable: false, align: 'left', width: 80, status: 'status' },
    { text: '经办人', value: 'operator', sortable: false, align: 'left', width: 120, status: 'status' },
    { text: '出库时间', value: 'stockTime', isFormatDate: true, sortable: false, width: 120, align: 'left', status: 'status' },
    {
      text: '状态',
      value: 'status',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h(
          'div',
          {
            style: {
              color: this.switchStatus(param.row[param.keyName])!.color
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          this.switchStatus(param.row[param.keyName])!.text
        );
      },
      width: 100
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      isDetail: [
        {
          routerName: 'outStock_detail',
          text: '查看',
          color: '#1ABC9C',
          query: { isDetail: true }
        },
        {
          routerName: 'outStock_edit',
          text: '修改',
          color: '#1ABC9C',
          query: { isEdit: true },
          isShowBtn: (row: any) => {
            return row.status === 'Pending' && Utils.isPermission('InventoryManager.StockOutOrder.CreateOrEdit');
          }
        },
        {
          routerName: 'outStock_approve',
          text: '审核',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status === 'Pending' && Utils.isPermission('InventoryManager.StockOutOrder.Approve');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.deleteStock(row.item.id);
          },
          text: '删除',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status === 'Pending' && Utils.isPermission('InventoryManager.StockOutOrder.Delete');
          }
        }
      ],
      width: 200
    }
  ];
  onStockTypeClear() {
    setTimeout(() => {
      this.form.stockType = '';
    }, 1);
  }
 @Watch('lastTime', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.stockEndTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTime', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.stockBeginTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('BeginTime', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }
  @Watch('EndTime', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as any).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as any).blur();
  }

  get minDate() {
    return this.form.stockBeginTime;
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  created() {
    this.getStaff();
    this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.startTime = this.form.stockBeginTime?moment(this.form.stockBeginTime as string).format('YYYY-MM-DD'):'';
      this.lastTime = this.form.stockEndTime?moment(this.form.stockEndTime as string).format('YYYY-MM-DD'):'';
    }
  }
  switchType(type: string) {
    switch (type) {
      case 'PurchaseReturn':
        return '采购退货';
      case 'Order':
        return '销售出库';
      case 'TransferOut':
        return '调拨出库';
      case 'Loss':
        return '盘亏出库';
      case 'OtherOut':
        return '其他出库';
      case 'MaterialOrder':
        return '物料申请出库';
    }
  }
  switchStatus(status: string) {
    switch (status) {
      case 'Pending':
        return { color: '#FE5500', text: '待审核' };
      case 'Stocked':
        return { color: '#00A854', text: '已出库' };
      case 'Cancel':
        return { color: '#999999', text: '已取消' };
    }
  }

  addOutStock() {
    this.$router.push({
      name: 'outStock_create'
    });
  }
  deleteStock(id: string) {
    this.deleteDialog = true;
    this.deleteItemId = id;
  }
  deleteSure() {
    this.requestLoading = true;
    deleteInstock(this.deleteItemId)
      .then((data: any) => {
        (this.$refs['formtable'] as HTMLFormElement).query();
        this.deleteDialog = false;
        this.deleteItemId = '';
      })
      .finally(() => {
        this.requestLoading = false;
      });
  }
  deleteCancel() {
    this.deleteDialog = false;
    this.deleteItemId = '';
    this.requestLoading = false;
  }
  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }
  onOperatorIdClear() {
    setTimeout(() => {
      this.form.operatorId = '';
    }, 1);
  }
  onStatusClear() {
    setTimeout(() => {
      this.form.status = '';
    }, 1);
  }
}
